<div class="mt-3">
  <p-accordion
    class="w-full"
    expandIcon="pi pi-angle-right"
    collapseIcon="pi pi-angle-down"
  >
    @for (faq of FAQs; track $index) {
      <p-accordion-panel [value]="$index">
        <p-accordion-header>
          <span class="flex align-items-center gap-2 w-full">
            <i [class]="faq.icon" style="color: #708090"></i>
            <span class="font-bold white-space-nowrap">{{ faq.title }}</span>
          </span>
        </p-accordion-header>
        <p-accordion-content>
          <div [innerHTML]="faq.content" class="text-justify"></div>
        </p-accordion-content>
      </p-accordion-panel>
    }
  </p-accordion>
</div>
